module.exports = __webpack_public_path__ + "img/Enhancements-Experiences-BG.6e6aa85e.jpg";